import { ApiRequest, SagaPayload } from 'types';
import { takeLatest } from 'redux-saga/effects';
// import { wimOperationalQualityMocks } from 'mocks/tim-operational-quality'; // mocks
import { getWimOperationalQualityAPI } from 'api/wim';
import makeRequestSaga from 'store/common';
import { requestWimOperationalQuality, getWimOperationalQualitySuccess, getWimOperationalQualityError } from './slice';

export function* wimWimOperationalQualityRequestSaga({ payload }: SagaPayload<ApiRequest>) {
  yield makeRequestSaga(
    getWimOperationalQualitySuccess,
    getWimOperationalQualityError,
    getWimOperationalQualityAPI,
    payload
  );
}

export function* wimWimOperationalQualityRequestWatchSaga() {
  yield takeLatest(requestWimOperationalQuality, wimWimOperationalQualityRequestSaga);
}
